import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'maporium-confirm-dialog',
  styles: [`
    pre {
      white-space: pre-wrap;
      word-wrap: break-word;
      overflow-x: auto;
      max-height: 90px;
      font-family: inherit;
      font-size: 14px;
      color: #494949;
    }

    .custom-checkbox {
      font-family: inherit !important;
      font-size: 14px !important;
    }

    .checkbox-label {
      font-family: inherit !important;
      font-size: 14px !important;
      color: #494949 !important;
      line-height: 1.4 !important;
    }

    .custom-checkbox .mdc-checkbox {
      padding: 8px;
    }

    .custom-checkbox .mdc-form-field {
      font-family: inherit !important;
      color: #494949 !important;
    }

    .custom-checkbox .mdc-form-field > label {
      color: #494949 !important;
      font-family: inherit !important;
    }

    /* Target Material Design checkbox label specifically */
    .custom-checkbox .mdc-form-field label {
      color: #494949 !important;
      font-family: inherit !important;
      font-size: 14px !important;
    }

    /* Target any spans inside the checkbox */
    .custom-checkbox span {
      color: #494949 !important;
      font-family: inherit !important;
    }
  `],
  template: `
    <div class="w-100 d-flex justify-content-between align-items-center dialog-header">
      <h2 class="align-items-center d-flex m-0 p-0">
        <i *ngIf="iconClass" [class]="iconClass" class="me-2"></i>
        <span *ngIf="!iconClass" class="material-symbols-rounded me-2">{{icon}}</span>
        {{title}}
      </h2>
      <span class="icon-smap-action-close close-button" mat-dialog-close [matTooltip]="'SHARE_DIALOG.CLOSE_TOOLTIP' | translate"></span>
    </div>
    <div mat-dialog-content>
      <p
        style="white-space: pre-line; font-size: 14px; color: #494949; line-height: 1.5; text-align: left;">{{ message }}</p>
      <pre *ngIf="errorMessage" [innerHTML]="errorMessage">
      </pre>
      <div *ngIf="showDoNotAskAgain" class="mt-3">
        <mat-checkbox [(ngModel)]="doNotShowAgain" class="custom-checkbox">
          <span class="checkbox-label">{{ 'MISC_DIALOGS.CONFIRMATION.DO_NOT_SHOW_AGAIN' | translate }}</span>
        </mat-checkbox>
      </div>
    </div>
    <div mat-dialog-actions class="d-flex justify-content-evenly">
      <button class="dialog-action-btn dialog-action-btn-cancel" mat-dialog-close *ngIf="showCancel">{{ cancelText }}
      </button>
      <button class="dialog-action-btn dialog-action-btn-primary" (click)="confirm()"
              cdkFocusInitial>{{ confirmText }}
      </button>
    </div>
  `,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatTooltipModule,
    MatCheckboxModule,
    CommonModule,
    MatIconModule,
    FormsModule,
    TranslatePipe
  ],
  standalone: true
})

export class ConfirmationDialogComponent {
  public title = 'Confirm Your Action';
  public message = 'This action is permanent, please confirm?';
  public errorMessage = undefined;
  public cancelText = 'Cancel';
  public confirmText = 'Confirm';
  public icon = 'warning';
  public iconClass: string | undefined;
  public showCancel = true;
  public showDoNotAskAgain = false;
  public doNotShowAgain = false;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private onConfirm = undefined;
  constructor(
    private matDialogRef: MatDialogRef<ConfirmationDialogComponent>,
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data?: {
      title?: string,
      message?: string,
      icon?: string,
      iconClass?: string,
      cancelText?: string,
      confirmText?: string,
      onConfirm?: () => void,
      showCancel?: boolean,
      errorMessage?: string,
      showDoNotAskAgain?: boolean
    }
  ) {
    this.title = this.translate.instant('MISC_DIALOGS.CONFIRMATION.DEFAULT_TITLE');
    this.message = this.translate.instant('MISC_DIALOGS.CONFIRMATION.DEFAULT_MESSAGE');
    this.cancelText = this.translate.instant('DASHBOARD_MSG.CONFIRM.CANCEL');
    this.confirmText = this.translate.instant('MISC_DIALOGS.CONFIRMATION.DEFAULT_CONFIRM');
    if (data) {
      this.title = data.title || this.title;
      this.message = data.message || this.message;
      this.icon = data.icon || this.icon;
      this.iconClass = data.iconClass;
      this.cancelText = data.cancelText || this.cancelText;
      this.confirmText = data.confirmText || this.confirmText;
      // @ts-ignore
      this.onConfirm = data.onConfirm || this.onConfirm;
      this.showCancel = data.showCancel !== undefined ? data.showCancel : this.showCancel;
      this.showDoNotAskAgain = data.showDoNotAskAgain !== undefined ? data.showDoNotAskAgain : this.showDoNotAskAgain;
      // @ts-ignore
      this.errorMessage = data.errorMessage || this.errorMessage;
    }
  }

  confirm() {
    if (this.onConfirm){
      // @ts-ignore
      this.onConfirm();
    }
    this.matDialogRef.close({ confirmed: true, doNotShowAgain: this.doNotShowAgain });
  }


  protected readonly undefined = undefined;
}
